<td-address-page scope="auctions" #page *transloco="let t">
    <h1 my-title>{{ t('auction-list.title-my') }}</h1>
    <span other-subtitle>{{ t('auction-list.title-owned-by') }}</span>
    <a title-side [routerLink]="['/address', page.address, 'auction-history']">{{ t('auction-list.history') }} <fa-icon icon="arrow-right"></fa-icon></a>

    <td-auction-table *ngIf="page.validAddress" [address]="page.address"></td-auction-table>
</td-address-page>
